import { jsx as _jsx } from "react/jsx-runtime";
var BookOpen = function BookOpen(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19 16.4023L13 17.7503V7.59735L19 6.25035V16.4023ZM5 6.25035L11 7.59735V17.7503L5 16.4023V6.25035ZM20.625 4.21835C20.387 4.02935 20.077 3.95735 19.78 4.02435L12 5.77235L4.22 4.02435C3.922 3.95635 3.613 4.02935 3.375 4.21835C3.138 4.40935 3 4.69635 3 5.00035V17.2023C3 17.6703 3.324 18.0753 3.78 18.1773L11.78 19.9753C11.854 19.9923 11.927 20.0003 12 20.0003C12.073 20.0003 12.146 19.9923 12.22 19.9753L20.22 18.1773C20.676 18.0753 21 17.6703 21 17.2023V5.00035C21 4.69635 20.862 4.40935 20.625 4.21835Z",
      fill: color
    })
  });
};
export default BookOpen;